import { render, staticRenderFns } from "./editNormalGoods.vue?vue&type=template&id=5090c4b0&scoped=true"
import script from "./editNormalGoods.vue?vue&type=script&lang=js"
export * from "./editNormalGoods.vue?vue&type=script&lang=js"
import style0 from "./editNormalGoods.vue?vue&type=style&index=0&id=5090c4b0&prod&scoped=true&lang=css"
import style1 from "./editNormalGoods.vue?vue&type=style&index=1&id=5090c4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090c4b0",
  null
  
)

export default component.exports